import { render, staticRenderFns } from "./LinksVip.vue?vue&type=template&id=97baaf62&scoped=true&"
import script from "./LinksVip.vue?vue&type=script&lang=ts&"
export * from "./LinksVip.vue?vue&type=script&lang=ts&"
import style0 from "./LinksVip.vue?vue&type=style&index=0&id=97baaf62&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97baaf62",
  null
  
)

export default component.exports